import { jsx as l, jsxs as a } from "react/jsx-runtime";
import "react";
var p = (h) => /* @__PURE__ */ a("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...h,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M20 0C11.4 0 4.07 5.428 1.244 13.043h37.512C35.93 5.428 28.6 0 20 0Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#000",
      d: "M20 40c8.6 0 15.93-5.427 18.756-13.044H1.244C4.07 34.573 11.401 40 20 40Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FF9811",
      d: "M26.956 17.826H21.74a1.74 1.74 0 1 0-3.478 0h-5.218c0 .96.837 1.74 1.797 1.74h-.057c0 .96.778 1.738 1.739 1.738 0 .96.778 1.74 1.739 1.74h3.478c.96 0 1.74-.78 1.74-1.74.96 0 1.738-.778 1.738-1.739h-.058c.96 0 1.797-.778 1.797-1.739Z"
    })
  ]
});
export {
  p as default
};
